module.exports = __webpack_public_path__ + "img/delivery-grafico.c4f9183a.svg";